import { styled } from "styled-components";

import HeaderBgImg from "../../assets/images/headerbg.png";
import { ReactComponent as Logo } from "../../assets/icons/KGLogo.svg";
import Navigation from "../molecules/Navigation";
import Socials from "../molecules/Socials";

const Header = () => {
  return (
    <StyledHeader>
      <a href="/">
        <StyledLogo />
      </a>
      <StyledHeadingWrapper>
        <h6>KAROL GUCWA</h6>
        <StyledHeading>
          Creating
          <br />
          <span>
            seamless
            <br />
            experience
          </span>
          <br />
          in web
          <img src={HeaderBgImg} alt="" />
        </StyledHeading>
      </StyledHeadingWrapper>

      <Navigation />

      <Socials />
    </StyledHeader>
  );
};

const StyledHeader = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 95vh;
  min-height: 550px;
`;

const StyledLogo = styled(Logo)`
  width: 35px;
  height: 40px;
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 99;
  @media (min-width: 400px) {
    width: 50px;
    height: 55px;
  }
`;

const StyledHeadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h6 {
    margin: 0;
    font-size: 12px;
  }
`;

const StyledHeading = styled.h1`
  font-size: 50px;
  word-wrap: break-word;
  position: relative;
  max-width: 100vw;
  margin: auto;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.highlightedText};
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
  }

  @media (max-width: 340px) {
    font-size: 40px;
  }
  @media (min-width: 500px) {
    font-size: 60px;
  }
  @media (min-width: 700px) {
    font-size: 80px;
  }
`;

export default Header;
